import { type FetchResult, type TypedDocumentNode, useMutation } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';
import { useCallback } from 'react';
import { GET_WAREHOUSE_INFO, UPDATE_WAREHOUSE_MUTATION } from 'src/api/warehouses.api';
import { notify } from 'src/lib/notify';
import type { UpdateWarehouse, UpdateWarehouseVariables } from 'types/graphql';

const UPDATE_WAREHOUSE: TypedDocumentNode<UpdateWarehouse, UpdateWarehouseVariables> = UPDATE_WAREHOUSE_MUTATION;

/** The warehouse's location groupings (`tagKeys`); refetches the warehouse header read. */
export function useUpdateWarehouse() {
  const [mutate, { loading, error }] = useMutation(UPDATE_WAREHOUSE, {
    refetchQueries: [GET_WAREHOUSE_INFO],
    onCompleted: () => {
      enqueueSnackbar('Warehouse updated successfully');
    },
    onError: (mutationError) => {
      notify.error(`Failed to update warehouse: ${mutationError.message}`);
    },
  });
  const update = useCallback(
    ({ id, input }: UpdateWarehouseVariables): Promise<FetchResult<UpdateWarehouse>> =>
      mutate({ variables: { id, input } }),
    [mutate]
  );

  return { update, loading, error };
}
